module.exports = __webpack_public_path__ + "img/_panama.962d59e8.png";